import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {OrganizationsComponent} from './features/organizations/pages/organizations/organizations.component';
import {Const} from './core/helpers/Const';
import {NotFoundComponent} from './features/organizations/pages/not-found/not-found.component';
import {AuthGuard} from './core/guard/auth.guard';
import {PrivateCloudGuard} from './core/guard/private-cloud.guard';
import {LoginComponent} from './features/organizations/pages/login/login.component';
import {HomeComponent} from './core/components/core/home/home.component';
import {FolderComponent} from './features/organizations/pages/folder/folder.component';
import {ResourcegroupComponent} from './features/organizations/pages/resourcegroup/resourcegroup.component';
import { CloudAutomationDesignerLoadDynamic } from "./extension/cloud-automation-designer/cloud-automation-designer-load-dynamic";
import {BlueprintDesignerLoadDynamic} from "./extension/blueprint-designer/blueprint-designer-load-dynamic";
import {ProductBlueprintModelerLoadDynamic} from "./extension/product-blueprint-modeler/product-blueprint-modeler-load-dynamic";

const routes: Routes = [
    { path: 'login', component: LoginComponent },
    {
        path: '',
        canActivate: [AuthGuard],
        component: HomeComponent,
        children: [
            {
                path: 'blueprintDesigner',
                component: BlueprintDesignerLoadDynamic
            },
            {
                path: 'cloudAutomationDesigner',
                component: CloudAutomationDesignerLoadDynamic,
                canActivate: [PrivateCloudGuard]
            },
            {
                path: 'cloudAutomationDesigner/designer',
                component: CloudAutomationDesignerLoadDynamic,
                canActivate: [PrivateCloudGuard]
            },
            {
                path: 'cloudAutomationDesigner/monitor',
                component: CloudAutomationDesignerLoadDynamic,
                canActivate: [PrivateCloudGuard]
            },
            {
                path: 'cloudAutomationDesigner/documentation',
                component: CloudAutomationDesignerLoadDynamic,
                canActivate: [PrivateCloudGuard]
            },
            {
                path: 'cloudAutomationDesigner/analysis',
                component: CloudAutomationDesignerLoadDynamic,
                canActivate: [PrivateCloudGuard]
            },
            {
                path: 'events',
                canActivate: [PrivateCloudGuard],
                loadChildren: () => import('./extension/events/events.module').then(m => m.EventsModule)
            },
            {
                path: 'productBlueprintModeler',
                component: ProductBlueprintModelerLoadDynamic
            },
            {
                path: 'productBlueprintModeler/designer',
                component: ProductBlueprintModelerLoadDynamic
            },
            {
                path: 'project',
                children: [
                    { path: '', redirectTo: Const.ALL_PROJECTS_PARAM, pathMatch: 'full' },
                    {
                        path: ':projectName',
                        children: [
                            {
                                path: 'organizations',
                                component: OrganizationsComponent,
                                pathMatch: 'full',
                                canActivate: [AuthGuard],
                            },
                            {
                                path: 'organizations/:orgName',
                                canActivate: [AuthGuard],
                                component: FolderComponent,
                            },
                            {
                                path: 'organizations/:orgName/folders',
                                component: FolderComponent,
                                canActivate: [AuthGuard],
                            },
                            {
                                path: 'organizations/:orgName/resource-groups',
                                component: ResourcegroupComponent,
                                canActivate: [AuthGuard],
                            },
                            { path: '', redirectTo: 'organizations', pathMatch: 'full' },
                        ],
                    },
                ],
            },
            { path: '', redirectTo: `project/${Const.ALL_PROJECTS_PARAM}`, pathMatch: 'full' },
            { path: '404', component: NotFoundComponent },
            { path: '**', redirectTo: '/404' },
        ],
    },
];
@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
